import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminProvider } from "@/context/AdminContext";
import { WhatsAppWidget } from "@/components/WhatsAppWidget";
import Home from "@/pages/Home";
import BookingStatus from "@/pages/BookingStatus";
import BookingCalendar from "@/pages/BookingCalendar";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const PAGE_TITLES = {
  "/": "Tirumala Tirupati Devasthanams Official Booking Portal | TTD Darshan & Seva Online",
  "/booking-calendar": "90-Day Booking Calendar | TTD Tirupati Darshan Online Booking",
  "/booking-status": "Check Booking Status | Tirumala Tirupati Devasthanams",
  "/admin": "Admin Login | TTD Devasthanams",
  "/admin/dashboard": "Admin Dashboard | TTD Devasthanams",
};

function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || "Tirumala Tirupati Devasthanams Official Booking Portal";
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <RouteTitle />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking-status" element={<BookingStatus />} />
          <Route path="/booking-calendar" element={<BookingCalendar />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppWidget />
      <Toaster position="top-right" richColors />
    </AdminProvider>
  );
}

export default App;
